import PageWrapper from "./src/js/component/wrapper/PageWrapper";
import RootWrapper from "./src/js/component/wrapper/RootWrapper";

export const wrapPageElement = PageWrapper;
export const wrapRootElement = RootWrapper;
